"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingConnection = void 0;
class StreamingConnection {
    constructor(url, onMessage, logger) {
        this.url = url;
        this.onMessage = onMessage;
        this.logger = logger;
        this.openConnection();
    }
    openConnection() {
        this.connection = new EventSource(this.url, { withCredentials: true });
        this.connection.onmessage = (event) => {
            this.onMessage(event.data);
        };
        this.connection.onerror = () => {
            this.logger.warn('StreamingConnection warning. Connection failed to establish.');
        };
        this.connection.onopen = () => {
            this.logger.debug('StreamingConnection opened');
        };
    }
    isConnected() {
        return this.connection.readyState === this.connection.OPEN;
    }
    reopen() {
        if (!this.isConnected()) {
            this.close();
            this.openConnection();
        }
    }
    close() {
        this.connection.close();
    }
}
exports.StreamingConnection = StreamingConnection;
//# sourceMappingURL=StreamingConnection.js.map